import Noty from 'noty';

function notify(message = 'Hi there!', body = '') {
  // Let's check if the browser supports notifications
  if (!('Notification' in window)) {
    alert('Your browsers done support notifications.');
  }

  // Let's check whether notification permissions have already been granted
  else if (Notification.permission === 'granted') {
    // If it's okay let's create a notification
    const notification = new Notification(message, { body });
  }

  // Otherwise, we need to ask the user for permission
  else if (Notification.permission !== 'denied') {
    Notification.requestPermission().then((permission) => {
      // If the user accepts, let's create a notification
      if (permission === 'granted') {
        const notification = new Notification(message, { body });
      }
    });
  } else if (Notification.permission === 'denied') {
    console.log('Notification permission was denied by user');
  }

  // At last, if the user has denied notifications, and you
  // want to be respectful there is no need to bother them any more.
}

function localNotify(message = 'Hi there!', type = 'alert') {
  console.log(`LocalNotification: ${type}-${message}`);
  Noty.setMaxVisible(15); // Sets the maxVisible notification count for global queue;
  // if the window is less than mobile size do not show the notification
  if (window.innerWidth < 768) return;
  new Noty({
    theme: 'sunset',
    layout: 'bottomRight',
    type,
    text: message,
    timeout: 3000,
    animation: {
      open: 'animated bounceInRight', // Animate.css class names
      close: 'animated fadeOut', // Animate.css class names
    },
  }).show();
}

export { notify, localNotify };
